// Exports
export default {
	"themeWrapper": "themeWrapper_DANh5",
	"title": "title_ms61a",
	"pickerWrapper": "pickerWrapper_Cqou3",
	"switchWrapper": "switchWrapper_LKl33"
};
